/* ─── Container ─── */

.root {
  width: 100%;
  margin-inline: auto;
  padding-inline: var(--page-px);
}

.default {
  max-width: var(--page-max);
}

.narrow {
  max-width: 40rem;
}

.wide {
  max-width: 96rem;
}

/* .fluid has no max-width constraint */
